export default [
  {
    title: 'main_menu.automation',
    customIcon: 'MkaIcon',
    path: '/mka',
    children: [],
  },
];
